__turbopack_context__.v({
  "emptyHint": "MethodsSection-module-scss-module__gzJjya__emptyHint",
  "methodLabel": "MethodsSection-module-scss-module__gzJjya__methodLabel",
  "methodList": "MethodsSection-module-scss-module__gzJjya__methodList",
  "methodOption": "MethodsSection-module-scss-module__gzJjya__methodOption",
  "methodTag": "MethodsSection-module-scss-module__gzJjya__methodTag",
  "methodWarning": "MethodsSection-module-scss-module__gzJjya__methodWarning",
  "scopeGroup": "MethodsSection-module-scss-module__gzJjya__scopeGroup",
  "section": "MethodsSection-module-scss-module__gzJjya__section",
  "sectionTitle": "MethodsSection-module-scss-module__gzJjya__sectionTitle",
  "targetChips": "MethodsSection-module-scss-module__gzJjya__targetChips",
});
